module.exports = __webpack_public_path__ + "80c99b9cca276440ca579a9b7337d0fd.fbx";